import { ref, useContext } from '@nuxtjs/composition-api';

const useFetchFaqs = () => {
  const { $api } = useContext();
  const faqs = ref();

  const fetchFaqs = async (productId: number) => {
    try {
      const { data } = await $api.faqsService.getAllFaqs({
        // @ts-ignore
        product_id: productId,
      });

      if (!data) return;
      faqs.value = data;
    } catch (e) {}
  };

  return { faqs, fetchFaqs };
};

export default useFetchFaqs;
